module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-searchbar"
  }, [_c('div', {
    staticClass: "c-searchbar__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "c-searchbar__search__query-input",
    attrs: {
      "type": "text",
      "name": "rewards_query_input",
      "placeholder": _vm.$t('web.catalog_search_bar.search_placeholder')
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryRewards($event)
      },
      "focus": _vm.toggleQueryInputFocused,
      "blur": _vm.toggleQueryInputFocused,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContextsDropdown),
      expression: "showContextsDropdown"
    }],
    staticClass: "c-searchbar__search__dropdown"
  }, _vm._l((_vm.contexts), function(context) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(_vm.query + ' <i>' + context.label + '</i>')
      },
      on: {
        "click": function($event) {
          return _vm.queryRewards($event, context.otherParams)
        }
      }
    })
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "c-searchbar__search__button t-button-plain-color",
    on: {
      "click": _vm.queryRewards
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-searchbar__saved-for-later",
    class: [_vm.isSavedRewardsPage ? 'u-disable-hover-cursor t-button-primary' : 't-button-plain-color'],
    attrs: {
      "to": {
        name: 'SavedRewards'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065beb4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/SearchBar.vue
// module id = 508
// module chunks = 1